"use client";

import Image from "next/image";
import React, { useState, useEffect } from "react";
import { passwordEye } from "../../../../public/Theme";
import ErrorTextWithIcon from "../../Typography/ErrorTextWithIcon/ErrorTextWithIcon";

const FloatingLabelInputField = ({
    errors,
    label,
    value = "",
    type,
    testid,
    placeholder,
    field,
    register = () => {},
    handleBlur = () => {},
    height = "",
    style = "",
    disabled,
    defaultValue,
    enableTranslation = false,
    translatedValue = "",
    getEnglishTranslation = async () => "",
    readOnly,
}) => {
    const [showPassword, setShowPassword] = useState(false);
    const [translation, setTranslation] = useState();
    const [isTranslating, setIsTranslating] = useState(false);

    const handleInputBlur = async (e) => {
        // Call the original handleBlur function first

        // If translation is enabled and there is a value, translate it
        if (enableTranslation && e.target.value) {
            setIsTranslating(true);
            try {
                const translated = await getEnglishTranslation(e.target.value);
                if (e.target.value !== translated?.data)
                    setTranslation(translated?.data);
            } catch (error) {
                console.error("Translation error:", error);
                setTranslation("Translation failed");
            } finally {
                setIsTranslating(false);
            }
        } else {
            setTranslation("");
        }
        handleBlur(e);
    };

    useEffect(() => {
        if (translatedValue) setTranslation(translatedValue);
    }, [translatedValue]);

    function isArabic(text) {
        // Arabic Unicode ranges: \u0600-\u06FF, \u0750-\u077F, \u08A0-\u08FF
        const arabicPattern = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
        // return arabicPattern.test("الكرام بتحويل الكتابة ");
        return arabicPattern.test(text);
    }

    return (
        <div className="flex-1">
            <div className="relative">
                <input
                    type={
                        type === "password"
                            ? showPassword
                                ? "text"
                                : "password"
                            : type
                    }
                    id={field}
                    testid={testid || field}
                    name={field}
                    {...register(field, {
                        onBlur: handleInputBlur,
                    })}
                    className={`w-full ${isTranslating || translation ? "h-16 pb-6" : "h-12 pb-2.5"} px-4 pt-6  ${disabled ? "bg-Ghost_White" : "bg-white"} rounded-[1px] outline-1 outline-offset-[-1px] outline ${disabled ? "outline-Light_Lavender" : "outline-[#ece9ee]"} focus:outline-neutral-800 appearance-none peer font-Poppins text-sm font-light ${disabled ? "text-Quick_Silver" : "text-[#262626]"} leading-[21px]`}
                    placeholder=" "
                    defaultValue={field !== "email" ? defaultValue : ""}
                    disabled={disabled}
                    readOnly={readOnly}
                />
                {type === "password" && (
                    <button
                        tabIndex={-1}
                        aria-label={
                            showPassword ? "Hide password" : "Show password"
                        }
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-600 hover:text-gray-800"
                    >
                        <Image
                            src={passwordEye}
                            alt={
                                showPassword ? "Hide password" : "Show password"
                            }
                            width={20}
                            height={20}
                        />
                    </button>
                )}
                {enableTranslation && isArabic(value) && (
                    <div className={`absolute bottom-0 left-4`}>
                        {isTranslating && (
                            <div className="text-sm text-gray-500 mt-1 font-Poppins">
                                Translating...
                            </div>
                        )}

                        {!isTranslating && translation && (
                            <div className="text-sm text-gray-600 mt-1 font-Poppins">
                                {translation}
                            </div>
                        )}
                    </div>
                )}
                <label
                    htmlFor={field}
                    className={`absolute left-4 text-sm font-Poppins font-light text-[#666666] leading-[21px] transition-all duration-300 
                    peer-focus:text-[10px] peer-focus:sm:text-[12px] peer-focus:font-normal peer-focus:text-[#333333] peer-focus:leading-[15px] peer-focus:top-[3px]
                    peer-[&:not(:placeholder-shown)]:text-[10px] peer-[&:not(:placeholder-shown)]:top-[3px] peer-[&:not(:placeholder-shown)]:font-normal ${disabled ? "peer-[&:not(:placeholder-shown)]:text-Quick_Silver" : "peer-[&:not(:placeholder-shown)]:text-[#333333]"} peer-[&:not(:placeholder-shown)]:leading-[15px]
                    peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2
                    peer-focus:translate-y-0`}
                >
                    {label}
                </label>
            </div>
            <ErrorTextWithIcon text={errors?.[field]?.message} />
        </div>
    );
};

export default FloatingLabelInputField;
